// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-tipo-2 {
  background-color: #6c757d;
  color: white;
  padding: 10px 20px;
  margin-left: 10px;
  border: none;
  border-radius: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/login-demo/login-demo.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".btn-tipo-2 {\r\n  background-color: #6c757d;\r\n  color: white;\r\n  padding: 10px 20px;\r\n  margin-left: 10px;\r\n  border: none;\r\n  border-radius: 1px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
